import { useMutation } from '@tanstack/react-query';
import {
  setTaskCalendarOverride,
  SetTaskCalendarOverrideInput,
} from 'shared/services/backend-api';

export const useSetTaskCalendarOverrideMutation = () =>
  useMutation({
    mutationFn: async (input: SetTaskCalendarOverrideInput) =>
      setTaskCalendarOverride(input),
  });
